






















































































































































import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'

const defaultLayout = 'default'

export default Vue.extend({
  name: 'App',
  data: () => {
    return {
      loading: true,
      currentUser: null as firebase.User | null
    }
  },
  computed: {
    layout () {
      return `${this.$route.meta.layout || defaultLayout}-layout`
    },
    ...mapGetters('ui', {
      snackbar: 'getSnackbar'
    })
  },
  methods: {
    ...mapActions('ui', { closeSnackbar: 'closeSnackbar' }),
    ...mapActions('results', ['updateChecksCounter']),
    isNewUser () {
      const source = localStorage.getItem('source')
      const medium = localStorage.getItem('medium')
      const campaign = localStorage.getItem('campaign')
      const content = localStorage.getItem('content')

      return !(source || medium || campaign || content)
    }
  },
  mounted () {
    if (location.host.includes('firebaseapp')) {
      location.host = 'truchecks-na.web.app' // Only use one domain to avoid cookie issues
      return
    }

    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        this.currentUser = null
        this.loading = false

        if (this.$route.name === 'Login' || this.$route.name === 'OAuthCallback') {
          return
        }

        this.$router.push({ name: 'Login' })
        return
      }

      this.currentUser = user
      this.loading = false

      if (this.$route.name === 'Login' || this.$route.name === 'OAuthCallback') {
        setTimeout(() => {
          this.$router.push({ name: 'Checks' })
        }, 1400)
      }
    })

    // @ts-ignore
    if (!this.isNewUser()) {
      return
    }

    const {
      utm_source: source,
      utm_medium: medium,
      utm_campaign: campaign,
      utm_content: content
    } = this.$route.query

    // items will be set as 'undefined' if not present on the query
    localStorage.setItem('source', source?.toString())
    localStorage.setItem('medium', medium?.toString())
    localStorage.setItem('campaign', campaign?.toString())
    localStorage.setItem('content', content?.toString())
  },
  watch: {
    $route () {
      // @ts-ignore
      this.closeSnackbar()
      // @ts-ignore
      this.updateChecksCounter()
    }
  }
})
